<template>
  <v-text-field v-model="value" @input="sync" :label="label" :readonly="readonly" :placeholder="label" :rules="rules" />
</template>

<script>
import DefaultField from './default'

export default {
  mixins: [DefaultField],
  data: () => ({
    value: 'float field'
  }),
  methods: {
    normalize () {
      let value = '' + this.value
      this.value = value.replace(',', '.')
      let norm = parseFloat(this.value)
      if (isNaN(norm)) {
        norm = ''
      }
      this.value = norm
    }
  }
}
</script>
